import { createAsyncThunk } from '@reduxjs/toolkit';
import { patchUpdatePrivateProjectBankItemName } from 'scenes/ProjectBank/services/private-project-bank/patchUpdateProjectBankItemName.service';
import { selectSelectedProjectId } from 'store/projects/selectors/projectsSelectors';

export const renamePrivateProjectBankItem = createAsyncThunk(
  'project-bank/renamePrivateProjectBankItem',
  async ({ itemId, newName }, { getState }) => {
    const projectId = selectSelectedProjectId(getState());

    const updatedItem = await patchUpdatePrivateProjectBankItemName(
      projectId,
      itemId,
      newName
    );

    return updatedItem;
  }
);
